import { twMerge } from "tailwind-merge";
import {
  CatalogLink,
  CatalogAutoplayButton,
  CatalogPagingButton,
} from "catalog/CatalogNavigations";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Anime, Image, Video } from "components/elements";

export default function GlobalNavigation() {
  const { pageSlug1, pageSlug2, pageSlug3, lang } = useParams();

  const [fullScreen, setFullScreen] = useState(false);
  const [isLnbActive, setIsLnbActive] = useState(false);

  useEffect(() => {
    const handleFullScreenChange = () => {
      setFullScreen(!!document.fullscreenElement);
    };

    const handleKeyPress = (e) => {
      if (e.key === "F11") {
        e.preventDefault();
        toggleFullScreen();
      }
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div className="pointer-events-none absolute left-0 top-0 z-[9999] h-full w-full">
      {pageSlug1 !== 'last' && (
      <header className={twMerge("max-md:fixed flex md:h-[80px] max-md:h-[60px] w-full items-center justify-between gap-8 *:pointer-events-auto", ['cover','catalog-index'].includes(pageSlug1) ? '' : ['intro'].includes(pageSlug2) ? '' : 'bg-[#F8F8F8]')}>
        <div className={twMerge('md:w-[285px] max-md:w-[130px] flex items-center justify-center h-full', pageSlug2 === 'cover1' ? 'bg-[#00510B]' : pageSlug2 === 'cover2' ? 'bg-[#005AE2]' : pageSlug2 === 'lineup' ? '' : pageSlug3 === 'intro1' ? 'bg-[#3BC5FF]' : pageSlug3 === 'intro2' ? 'bg-[#9CA1AF]' : 'bg-[#454545]', pageSlug1 === 'catalog-index' && 'index-logo')}>
          <CatalogLink to="/">
            {pageSlug2 === 'lineup' ? (
              <Image src="logo-color.png" alt="logo" />
            ) : (
              <Image src="logo.png" alt="logo" />
            )}
          </CatalogLink>
        </div>
        <div className="flex items-center justify-end flex-1 menu h-full">
          {(!['cover','catalog-index'].includes(pageSlug1) && !['intro'].includes(pageSlug2)) && (
            <nav className="flex gap-[119px] text-xl mx-auto md:translate-x-[-50px] max-md:hidden h-full">
              {/* <CatalogLink className={twMerge(pageSlug1 === "cover" && "!text-[#0099FF]")} to="/cover">
                INTRO
              </CatalogLink> */}
              {/* COMPANY */}
              <div
                className={twMerge("relative flex items-center cursor-pointer", pageSlug1 === "company" && "active")}
                onMouseEnter={() => setIsLnbActive("company")}
                onMouseLeave={() => setIsLnbActive(false)}
              >
                <CatalogLink
                  className={twMerge(pageSlug1 === "company" && "!text-[#0099FF]")}
                  to="company/about/introduce"
                >
                  COMPANY
                </CatalogLink>
              </div>

              {/* TECHNOLOGY */}
              <div
                className={twMerge("relative flex items-center cursor-pointer", pageSlug1 === "technology" && "active")}
                onMouseEnter={() => setIsLnbActive("technology")}
                onMouseLeave={() => setIsLnbActive(false)}
              >
                <CatalogLink
                  className={twMerge(pageSlug1 === "technology" && "!text-[#0099FF]")}
                  to="/technology/intro/intro1"
                >
                  TECHNOLOGY
                </CatalogLink>
              </div>

              {/* PRODUCT */}
              <div
                className={twMerge("relative flex items-center cursor-pointer", pageSlug1 === "product" && "active")}
                onMouseEnter={() => setIsLnbActive("product")}
                onMouseLeave={() => setIsLnbActive(false)}
              >
                <CatalogLink
                  className={twMerge(pageSlug1 === "product" && "!text-[#0099FF]")}
                  to="/product/lineup"
                >
                  PRODUCT
                </CatalogLink>
              </div>
            </nav>
          )}
          {/* <nav className="lang flex md:gap-[40px] max-md:gap-[20px] mr-[19px]">
            <a href="#/ko/cover/cover1" className={twMerge((lang === 'ko' && (['cover'].includes(pageSlug1) || ['intro'].includes(pageSlug2))) ? '!text-white' : lang === 'ko' ? '!text-[#005AE2] active' : ['cover'].includes(pageSlug1) ? '!text-[#ADADAD]' : ['catalog-index'].includes(pageSlug1) ? '!text-white' : '', (!['cover'].includes(pageSlug1) && !['intro'].includes(pageSlug2)) ? 'relative' : '')}>KOR</a>
            <a href="#/en/cover/cover1" className={(lang === 'en' && (['cover'].includes(pageSlug1) || ['intro'].includes(pageSlug2))) ? '!text-white' : lang === 'en' ? '!text-[#005AE2] active' : ['cover'].includes(pageSlug1) ? '!text-[#ADADAD]' : ['catalog-index'].includes(pageSlug1) ? '!text-white' : ''}>ENG</a>
          </nav> */}
          <nav id="lang_nav" className={twMerge("lang_nav lang_nav--dropdown--text", !(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? 'gray' : '')}>
            <span className="cur">
              {lang === 'ko' ? 'KOR' : 'ENG'}
            </span>
            <ul className="ls">
              <li>
                <a href={`#/${lang === 'ko' ? 'en' : 'ko'}/cover/cover1`}>
                  {lang === 'ko' ? 'ENG' : 'KOR'}
                </a>
              </li>
            </ul>
          </nav>
          <nav className="flex md:gap-[20px] text-xl items-center">
            <CatalogAutoplayButton
              className="btn btn-play max-md:pr-[15px]"
              render={{
                play: ['cover', 'catalog-index'].includes(pageSlug1) || pageSlug2 === 'intro' ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="23" viewBox="0 0 22 26">
                    <g id="다각형_2" data-name="다각형 2" transform="translate(22) rotate(90)" fill="none">
                      <path d="M 12.99999618530273 2.89704704284668 C 14.00109004974365 2.89704704284668 15.00218486785889 3.388317108154297 15.58277988433838 4.370857238769531 L 23.32542991638184 17.47380828857422 C 24.50716018676758 19.47365760803223 23.06555938720703 21.99999809265137 20.74266052246094 21.99999809265137 L 5.257339477539062 21.99999809265137 C 2.934440612792969 21.99999809265137 1.492839813232422 19.47365760803223 2.674560546875 17.47380828857422 L 10.41722011566162 4.370857238769531 C 10.99781036376953 3.388317108154297 11.99890232086182 2.89704704284668 12.99999618530273 2.89704704284668 Z"
                        fill="none" 
                        stroke="#fff" 
                        strokeWidth="2"
                        strokeMiterlimit="10"/>
                    </g>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="23" viewBox="0 0 22 26">
                    <g id="다각형_2" data-name="다각형 2" transform="translate(22) rotate(90)" fill="none">
                      <path d="M 12.99999618530273 2.89704704284668 C 14.00109004974365 2.89704704284668 15.00218486785889 3.388317108154297 15.58277988433838 4.370857238769531 L 23.32542991638184 17.47380828857422 C 24.50716018676758 19.47365760803223 23.06555938720703 21.99999809265137 20.74266052246094 21.99999809265137 L 5.257339477539062 21.99999809265137 C 2.934440612792969 21.99999809265137 1.492839813232422 19.47365760803223 2.674560546875 17.47380828857422 L 10.41722011566162 4.370857238769531 C 10.99781036376953 3.388317108154297 11.99890232086182 2.89704704284668 12.99999618530273 2.89704704284668 Z"
                        fill="none" 
                        stroke="#8F8F8F" 
                        strokeWidth="2"
                        strokeMiterlimit="10"/>
                    </g>
                  </svg>
                ),
                pause: ['cover', 'catalog-index'].includes(pageSlug1) || pageSlug2 === 'intro' ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20.826" viewBox="0 0 16 20.826">
                    <g id="그룹_28270" data-name="그룹 28270" transform="translate(-1825.189 -29.587)">
                      <path id="패스_34871" data-name="패스 34871" d="M-5459.561,7539.33v20.826" transform="translate(7286 -7509.742)" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
                      <path id="패스_34872" data-name="패스 34872" d="M-5459.561,7539.33v20.826" transform="translate(7298.561 -7509.742)" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
                    </g>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20.826" viewBox="0 0 16 20.826">
                    <g id="그룹_28270" data-name="그룹 28270" transform="translate(-1825.189 -29.587)">
                      <path id="패스_34871" data-name="패스 34871" d="M-5459.561,7539.33v20.826" transform="translate(7286 -7509.742)" fill="none" stroke="#8f8f8f" strokeWidth="2.5" strokeLinecap="round"/>
                      <path id="패스_34872" data-name="패스 34872" d="M-5459.561,7539.33v20.826" transform="translate(7298.561 -7509.742)" fill="none" stroke="#8f8f8f" strokeWidth="2.5" strokeLinecap="round"/>
                    </g>
                  </svg>
                ),
              }}
            ></CatalogAutoplayButton>
            <button
              className={twMerge("view md:pr-[29px] max-md:pr-[15px]", "mo:hidden", fullScreen ? "active" : "")}
              onClick={toggleFullScreen}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="21.541" height="21.54" viewBox="0 0 22 22">
                <g id="그룹_16729" data-name="그룹 16729" transform="translate(1.25 1.25)">
                  <path id="패스_42" data-name="패스 42" d="M0,6.689V0H6.689" fill="none" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2.5" strokeLinecap="round"/>
                  <path id="패스_34865" data-name="패스 34865" d="M6.69,6.689V0H0" transform="translate(12.351)" fill="none" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2.5" strokeLinecap="round"/>
                  <path id="패스_34866" data-name="패스 34866" d="M0,0V6.689H6.689" transform="translate(0 12.351)" fill="none" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2.5" strokeLinecap="round"/>
                  <path id="패스_34867" data-name="패스 34867" d="M6.69,0V6.689H0" transform="translate(12.351 12.351)" fill="none" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2.5" strokeLinecap="round"/>
                </g>
              </svg>
            </button>
            <CatalogLink to="/catalog-index" className={twMerge("md:p-[31.5px] max-md:pr-[15px] md:hidden", "mo:hidden")}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19" fill="none">
                <line x1="3" y1="1" x2="21" y2="1" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="9.5" x2="21" y2="9.5" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke={(['cover', 'catalog-index'].includes(pageSlug1) || ['intro'].includes(pageSlug2)) ? '#fff' : '#8F8F8F'} strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </CatalogLink>
          </nav>
        </div>
      </header>
      )}
      {['cover', 'catalog-index', 'last'].includes(pageSlug1) || ['intro'].includes(pageSlug2) ? '' : (
        <div className={twMerge("lnb-container")}>
          {/* COMPANY 드롭다운 */}
          <nav
            className={twMerge("lnb-bar company", isLnbActive === "company" && "active")}
            onMouseEnter={() => setIsLnbActive("company")}
            onMouseLeave={() => setIsLnbActive(false)}
          >
            <ul>
              <li>
                <p>
                  {lang === 'ko' ? '회사소개' : 'Company Introduction'}
                </p>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "about" && "active")}
                  to="company/about/introduce"
                >
                  About Gaontech?
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "why" && "active")}
                  to="company/why"
                >
                  Why is Gaontech?
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "history" && "active")}
                  to="company/history"
                >
                  {lang === 'ko' ? '연혁' : 'History'}
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "development" && "active")}
                  to="company/development"
                >
                  {lang === 'ko' ? '연구개발' : 'Research & Development (R&D)'}
                </CatalogLink>
              </li>
            </ul>
            <ul>
              <li>
                <p>
                  {lang === 'ko' ? '특허 및 인증' : 'Patents & Certifications'}
                </p>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "cert" && "active")}
                  to="company/cert/cert1"
                >
                  {lang === 'ko' ? '특허 및 인증' : 'Patents & Certifications'}
                </CatalogLink>
              </li>
            </ul>
            <ul>
              <li>
                <p>
                  {lang === 'ko' ? '글로벌 네트워크' : 'Global Network'}
                </p>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "global" && "active")}
                  to="company/global"
                >
                  {lang === 'ko' ? '글로벌 공급망' : 'Global Supply Chain'}
                </CatalogLink>
              </li>
            </ul>
          </nav>

          {/* TECHNOLOGY 드롭다운 */}
          <nav
            className={twMerge("lnb-bar technology", isLnbActive === "technology" && "active")}
            onMouseEnter={() => setIsLnbActive("technology")}
            onMouseLeave={() => setIsLnbActive(false)}
          >
            <ul>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug3 === "overview1" && "active")}
                  to="technology/overview/overview1"
                >
                  {lang === 'ko' ? '열교환기란?' : 'What is a heat exchanger?'}
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug3 === "overview2" && "active")}
                  to="/technology/overview/overview2"
                >
                  {lang === 'ko' ? '원소재(ER paper, Membrane)' : 'Base materials'}
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug3 === "overview3" && "active")}
                  to="/technology/overview/overview3"
                >
                  {lang === 'ko' ? '직교류형 열교환기' : 'Cross-flow heat exchanger'}
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug3 === "overview4" && "active")}
                  to="/technology/overview/overview4"
                >
                  {lang === 'ko' ? '대향류형 열교환기' : 'Counter-flow heat exchanger'}
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug3 === "overview5" && "active")}
                  to="/technology/overview/overview5"
                >
                  {lang === 'ko' ? '적용분야' : 'Applications'}
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug3 === "overview6" && "active")}
                  to="/technology/overview/overview6"
                >
                  {lang === 'ko' ? '다양한 제품' : 'Various products'}
                </CatalogLink>
              </li>
            </ul>
          </nav>

          {/* PRODUCT 드롭다운 */}
          <nav
            className={twMerge("lnb-bar product", isLnbActive === "product" && "active")}
            onMouseEnter={() => setIsLnbActive("product")}
            onMouseLeave={() => setIsLnbActive(false)}
          >
            <ul>
              <li>
                <p>
                  {lang === 'ko' ? '직교류형' : 'Cross-flow type'}
                </p>
                <span>
                  {lang === 'ko' ? '전열교환기' : 'Total heat exchanger'}
                </span>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "pce-ex" && "active")}
                  to="/product/pce-ex/cont1"
                >
                  PCE-EX
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "pce-pex" && "active")}
                  to="/product/pce-pex/cont1"
                >
                  PCE-PEX
                </CatalogLink>
              </li>
              <li>
                <span>
                  {lang === 'ko' ? '현열교환기' : 'Sensible heat exchanger'}
                </span>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "pch-phx" && "active")}
                  to="/product/pch-phx/cont1"
                >
                  PCH-PHX
                </CatalogLink>
              </li>
              <li>
                <span>
                  {lang === 'ko' ? '대형 전열/현열' : 'Large total/sensible heat exchanger'}
                </span>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "d-type" && "active")}
                  to="/product/d-type/cont1"
                >
                  D-TYPE
                </CatalogLink>
              </li>
            </ul>
            <ul>
              <li>
                <p>
                  {lang === 'ko' ? '대향류형' : 'Counter-flow Type'}
                </p>
                <span>
                  {lang === 'ko' ? '전열교환기' : 'Total heat exchanger'}
                </span>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "pde-366" && "active")}
                  to="/product/pde-366/cont1"
                >
                  PDE-366
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "pde-f" && "active")}
                  to="/product/pde-f/cont1"
                >
                  PDE-F series
                </CatalogLink>
              </li>
              <li>
                <span>
                  {lang === 'ko' ? '현열교환기' : 'Sensible heat exchanger'}
                </span>
                <CatalogLink
                  className={twMerge("lnb", pageSlug2 === "pdh-271" && "active")}
                  to="/product/pdh-271/cont1"
                >
                  PDH-271
                </CatalogLink>
              </li>
            </ul>
            <ul>
              <li>
                <p>
                  {lang === 'ko' ? '필터' : 'Filter'}
                </p>
                <CatalogLink
                  className={twMerge("lnb", (pageSlug2 === "filter" && pageSlug3 === "cont1") && "active")}
                  to="/product/filter/cont1"
                >
                  PRE FILTER
                </CatalogLink>
              </li>
              <li>
                <CatalogLink
                  className={twMerge("lnb", (pageSlug2 === "filter" && pageSlug3 === "cont2") && "active")}
                  to="/product/filter/cont2"
                >
                  Medium / HEPA / <br />OSFAM HEPA FILTER
                </CatalogLink>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {pageSlug1 !== 'last' && (
      <nav className="md:absolute max-md:fixed bottom-0 left-0 flex w-full justify-between px-[27px] py-[29px] *:pointer-events-auto">
        { pageSlug2 !== 'cover1' && (
          <CatalogPagingButton
            direction="prev"
            className="disabled:opacity-50 rotate-[180deg]"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="27.613" height="24.369" viewBox="0 0 27.613 24.369">
              <g id="그룹_16664" data-name="그룹 16664" transform="translate(0 1.061)">
                <g id="그룹_22" data-name="그룹 22" transform="translate(0 0)">
                  <path id="패스_21" data-name="패스 21" d="M15.732,15.732V0H0" transform="translate(14.367 0) rotate(45)" fill="none" stroke={(['cover'].includes(pageSlug1)) ? '#fff' : (['intro', 'lineup'].includes(pageSlug2) || ['overview5'].includes(pageSlug3)) ? '#fff' : '#000'} strokeMiterlimit="10" strokeWidth="3"/>
                  <line id="선_1" data-name="선 1" x2="25.275" transform="translate(0 10.912)" fill="none" stroke={(['cover'].includes(pageSlug1)) ? '#fff' : (['intro', 'lineup'].includes(pageSlug2) || ['overview5'].includes(pageSlug3)) ? '#fff' : '#000'} strokeWidth="3"/>
                </g>
              </g>
            </svg>
          </CatalogPagingButton>
        )}
        <CatalogPagingButton
          direction="next"
          className="disabled:opacity-50 ml-auto"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="27.613" height="24.369" viewBox="0 0 27.613 24.369">
            <g id="그룹_16664" data-name="그룹 16664" transform="translate(0 1.061)">
              <g id="그룹_22" data-name="그룹 22" transform="translate(0 0)">
                <path id="패스_21" data-name="패스 21" d="M15.732,15.732V0H0" transform="translate(14.367 0) rotate(45)" fill="none" stroke={['cover'].includes(pageSlug1) ? '#fff' : (['intro'].includes(pageSlug2) || ['overview5'].includes(pageSlug3)) ? '#fff' : '#000'} strokeMiterlimit="10" strokeWidth="3"/>
                <line id="선_1" data-name="선 1" x2="25.275" transform="translate(0 10.912)" fill="none" stroke={['cover'].includes(pageSlug1) ? '#fff' : (['intro'].includes(pageSlug2) || ['overview5'].includes(pageSlug3)) ? '#fff' : '#000'} strokeWidth="3"/>
              </g>
            </g>
          </svg>
        </CatalogPagingButton>
      </nav>
      )}
    </div>
  );
}
